import { mapState } from "vuex";

//1:基础版，2:高级版，3:商业版，6：定制版
const packageInfo = [
  {
    packageId: 0,
    packageName: "暂无权益",
    describe: "管理员暂未给您分配权益，请联系管理员分配",
    privilegesLink: null,
    class: "normal-bg",
    buttonText: null,
    payLink: null,
    vip: false,
  },
  {
    packageId: 1,
    packageName: "企业基础版",
    describe: "购买套餐即享海量特权",
    privilegesLink: "/priceDetail",
    class: "normal-bg",
    buttonText: "立即购买",
    payLink: "https://dy.foxitcloud.cn/clientPay/printvip/",
    vip: false,
  },
  {
    packageId: 2,
    packageName: "企业高级版",
    describe: "升级套餐即享海量特权",
    privilegesLink: "/priceDetail",
    class: "normal-bg",
    buttonText: "立即购买",
    payLink: "https://dy.foxitcloud.cn/clientPay/printvip/",
    vip: false,
  },
  {
    packageId: 3,
    packageName: "企业商业版",
    describe: "您已拥有海量专享特权",
    privilegesLink: "/priceDetail",
    class: "equity-vip",
    buttonText: "立即续费",
    payLink: "https://dy.foxitcloud.cn/clientPay/printvip/",
    vip: true,
  },
  {
    packageId: 6,
    packageName: "企业定制版",
    describe: "您已拥有海量专享特权",
    privilegesLink: "/priceDetail",
    class: "equity-vip",
    buttonText: "立即续费",
    payLink: "https://dy.foxitcloud.cn/clientPay/printvip/",
    vip: true,
  },
];
//个人账号列表
const guestList = [
  {
    packageName: "您还不是会员",
    describe: "开通会员即享海量特权",
    privilegesLink: "https://vip.foxitsoftware.cn/privileges.html",
    class: "normal-bg",
    buttonText: "立即开通",
    payLink: "https://dy.foxitcloud.cn/clientPay/printvip/",
    vip: false,
  },
  {
    packageName: "打印权益包",
    describe: "您已拥有海量专享特权",
    privilegesLink: "https://vip.foxitsoftware.cn/privileges.html",
    class: "equity-vip",
    buttonText: "立即续费",
    payLink: "https://dy.foxitcloud.cn/clientPay/printvip/",
    vip: true,
  },
];

//过滤取值packageInfo列表，对应套餐加载对应文案及样式
const filterPackageInfo = function(userVipInfo) {
  if (userVipInfo && userVipInfo.vip) {
    return guestList[1];
  }
  return guestList[0];
};

//获取福昕会员vip\福昕办公套餐过期时间
const getVipExpireTime = function(userVipInfo) {
  if (userVipInfo && userVipInfo.vip && userVipInfo.expirationTime) {
    return userVipInfo.expirationTime.split(" ")[0];
  }
  return false;
};
export const headerMixin = {
  data() {
    return {
      userVipInfo: null,
    };
  },
  computed: {
    ...mapState("user", [
      "userInfo",
      "userType",
      "maxSize",
      "currentSize",
      "accounts",
    ]),
    dropDownTabulation() {
      return [
        {
          img: require("../assets/img/headers/drop/part1.png"),
          text: "账号中心",
          url: this.accessToken
            ? "https://account.foxitreader.cn/usercenter/"
            : "https://vip.foxitsoftware.cn/personal.html",
        },
        {
          img: require("../assets/img/headers/drop/part2.png"),
          text: "兑换会员",
          url: "https://www.pdf365.cn/duihuan/index.html",
        },
        {
          img: require("../assets/img/headers/drop/part3.png"),
          text: "我的订单",
          url: "https://dy.foxitcloud.cn/order/",
        },
        {
          img: require("../assets/img/headers/drop/part4.png"),
          text: "帮助/反馈",
          url: "https://www.foxitsoftware.cn/dayin/help.html",
        },
      ];
    },
    //packageInfo列表
    tabulationItem() {
      return filterPackageInfo(this.userVipInfo);
    },
    //获取vip会员过期时间
    getVipExpireTime() {
      return getVipExpireTime(this.userVipInfo);
    },
  },
  methods: {
    //退出登录
    signOut() {
      window.location.href =
        "https://account.foxitreader.cn/logout.html?redirectUrl=https://www.foxitcloud.cn/";
      sessionStorage.clear();
    },
    //获取当前账号激活class
    getActiveClass(userInfo, data) {
      if (userInfo.roleName !== "guest") {
        return userInfo.companyId === Number(data.companyId);
      }
      return userInfo.ssoUserId === Number(data.accountId);
    },
  },
};
